import { Card, Typography } from "antd"
import { InvoicingSettings } from "../../../domain/invoicing/settings/invoicingSettings"
import { useUpdateDefaultIncludePaymentSummaryMutation } from "../../../domain/invoicing/settings/invoicingSettingsQueries"
import LabeledSwitch from "../../common/LabeledSwitch"

type Props = {
  serverSettings: InvoicingSettings
}

const PaymentSummaryDefaultCard = ({ serverSettings }: Props) => {
  const mutation = useUpdateDefaultIncludePaymentSummaryMutation()

  if (serverSettings.invoicingSystem !== 'synkedUp') {
    return <></>
  }

  const isEnabled = serverSettings.defaultIncludePaymentSummary

  return <Card
    title={<div style={{ margin: "16px 0" }}>
      Payment Summary on Invoices
      <br/>
      <Typography.Text type="secondary" style={{fontWeight: 'normal', textWrap: 'wrap'}}>
        When enabled, new invoices include a payment summary — the job total, payments made, and remaining
        balance — on the customer's invoice by default. You can still change this for each invoice.
      </Typography.Text>
    </div>}
  >
    <LabeledSwitch
      label={isEnabled ? 'Enabled' : 'Disabled'}
      value={isEnabled}
      loading={mutation.isLoading}
      disabled={mutation.isLoading}
      onChange={enabled => mutation.mutate(enabled)}
    />
  </Card>
}

export default PaymentSummaryDefaultCard
